export const hasProperty = (source, param) => {
  if (!source) return false;
  return Object.prototype.hasOwnProperty.call(source, param);
};
